"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _theme = require("../styles/theme");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var WrapperDiv = (
/*#__PURE__*/
0, _styledBase.default)('div', {
  target: "eghs12a0",
  label: "WrapperDiv"
})("font-family:", _theme.fonts.sans.family, ";border:1px solid ", _theme.colors.red.primary, ";background-color:rgba(255,0,0,0.2);padding:15px;color:red;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb21wb25lbnRzL2ludGVybmFsL0NvbXBvbmVudEVycm9yLmpzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFLZ0MiLCJmaWxlIjoiLi4vLi4vc3JjL2NvbXBvbmVudHMvaW50ZXJuYWwvQ29tcG9uZW50RXJyb3IuanN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSAncHJvcC10eXBlcyc7XG5pbXBvcnQgeyBmb250cywgY29sb3JzIH0gZnJvbSAnLi4vc3R5bGVzL3RoZW1lJztcblxuY29uc3QgV3JhcHBlckRpdiA9IHN0eWxlZCgnZGl2JylgXG4gIGZvbnQtZmFtaWx5OiAke2ZvbnRzLnNhbnMuZmFtaWx5fTtcbiAgYm9yZGVyOiAxcHggc29saWQgJHtjb2xvcnMucmVkLnByaW1hcnl9O1xuICBiYWNrZ3JvdW5kLWNvbG9yOiByZ2JhKDI1NSwgMCwgMCwgMC4yKTtcbiAgcGFkZGluZzogMTVweDtcbiAgY29sb3I6IHJlZDtcbmA7XG5cbmNvbnN0IEVycm9yRGlzcGxheSA9IChwcm9wcykgPT4ge1xuICBjb25zdCB7IGNoaWxkcmVuIH0gPSBwcm9wcztcbiAgcmV0dXJuIChcbiAgICA8V3JhcHBlckRpdj5cbiAgICAgIDxzcGFuPkNvbXBvbmVudCBFcnJvcjogPC9zcGFuPlxuICAgICAge2NoaWxkcmVufVxuICAgIDwvV3JhcHBlckRpdj5cbiAgKTtcbn07XG5cbkVycm9yRGlzcGxheS5wcm9wVHlwZXMgPSB7XG4gIGNoaWxkcmVuOiBQcm9wVHlwZXMub25lT2ZUeXBlKFtQcm9wVHlwZXMuZWxlbWVudCwgUHJvcFR5cGVzLnN0cmluZ10pLmlzUmVxdWlyZWRcbn07XG5cbmV4cG9ydCBkZWZhdWx0IEVycm9yRGlzcGxheTtcbiJdfQ== */"));

var ErrorDisplay = function ErrorDisplay(props) {
  var children = props.children;
  return _react.default.createElement(WrapperDiv, null, _react.default.createElement("span", null, "Component Error: "), children);
};

ErrorDisplay.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.string]).isRequired
};
var _default = ErrorDisplay;
exports.default = _default;